import React from 'react';
import { HVAConversationProvider } from './HVAContractVerificationContext';
import HVADynamicConversationModalContent from './HVAContractVerificationModalContent';
import { HVADynamicConversationModalProps } from './HVAContractVerificationData';

const HVAContractVerificationModal: React.FC<
  HVADynamicConversationModalProps
> = props => {
  return (
    <HVAConversationProvider>
      <HVADynamicConversationModalContent {...props} />
    </HVAConversationProvider>
  );
};

export default HVAContractVerificationModal;
